const GetServiceNameImagePath = (serviceName) => {
     const serviceImage = {
        "Mobile/DTH Recharge"           : "recharge.png",
        "Mobile Recharge"               : "recharge.png",
        "DTH Recharge"                  : "dth.png",
        "Utility Bill Payment"          : "Utility.png",
        "AEPS"                          : "aeps.png",
        "DMT"                           : "dmt.png",
        "Flight Booking"                : "flight.png",
        "Cashdrop"                      : "Cash_Collection.png",
        "Dhanak"                        : "dhanak.png",
        "Payment Gateway Credit Card"   : "Payment_Gateway.png",
        "Daily Invest"                  : "Daily_invest.png",
        "Dhanak Refurb"                 : "dhanakRefurb.png",
        "Dhanak Device Hub"             : "dhanakHub.png",
        "IRCTC"                         : "irctc.png",
        "Pancard"                       : "pan_card.png",
        "Bonus"                         : "bonus.svg",
        "Membership Rental"             : "other.png",
        "Online Topup"                  : "topup.svg",
        "MicroATM"                      : "atm.png",
        "All Rounder"                   : "all_rounder.png",
        "Saarthi Bonus"                 : "saarthi_bonus.png",
        "Saarthi Bonus Points"          : "saarthi_bonus_points.png",
        "Cash Rotation Bonus"           : "cash_rotation_bonus.png",
        "ppi"                           : "ppi.png",
        "Payment Gateway ( Partner Portal )"            : "gatway_portal.png",
        "Bill Payment ( Partner Portal )"               : "utility_portal.png",
     }
     let serviceImageName = "other.png";
     if (Object.keys(serviceImage).includes(serviceName)) {
        serviceImageName = serviceImage[serviceName];
     }
     return serviceImageName;
}

export default GetServiceNameImagePath;